import React from 'react';
import './Sections.scss';
import Hyperlink from '../Hyperlink/Hyperlink';

function Section1() {
  const hyperlinkData = [
    {
      href: 'https://www.nar.realtor/research-and-statistics/research-reports/highlights-from-the-profile-of-home-buyers-and-sellers',
      copy: '2022 Home Buyers and Sellers Report',
      label: 'Visit Highlights From the Profile of Home Buyers and Sellers'
    }
  ];

  return (
    <section className="sections sections-section1">
      <p className="sections-copy">
        Americans looking to buy their first home are facing a challenging market. In fact, only 26%
        of recent home purchases were made by first-time buyers, according to the National
        Association of Realtors®' <Hyperlink hyperlinkData={hyperlinkData[0]} />. That’s an all-time
        low and down from 34% last year. Compare this to the historical average of 40%, or to recent
        highs in 2010, when a special First-time Buyer Tax Credit prompted first-time buyers to
        comprise a staggering 50% of all home buyers.
      </p>
      <p className="sections-copy">
        In the midst of challenging market conditions, many homebuyers are finding creative pathways
        to ownership, rethinking whom they live with, and availing themselves of underutilized
        financing programs to get the keys to their first house.
      </p>
    </section>
  );
}

export default Section1;
